import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface Props {
  children: React.ReactNode;
  onClickYes: () => void | Promise<void>;
  onClickNo: () => void;
}

/**
 * Yes / No ボタンがあるモーダル
 * @param param0
 * @returns
 */
function YesNoModal({ children, onClickYes, onClickNo }: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      active
      additionalClassName="popupfr340"
      displayCloseButton={false}
      onClose={() => {
        /* do nothing */
      }}
    >
      {children}
      <div className="mb0">
        <input type="button" className="red-button" value={t('Yes').toString()} onClick={onClickYes} />
        <input type="button" className="red-button ml10" value={t('No').toString()} onClick={onClickNo} />
      </div>
    </Modal>
  );
}

export default YesNoModal;
